import React from 'react'
import {
    Create,
    Edit,
    required,
    SelectInput,
    SimpleForm,
    TextInput,
} from 'react-admin'
import { useLocation } from 'react-router-dom'

const currencyBRL = (value) => {
    value = value.replace('.', '')
    return value
}

const currencyChoices = [
    { id: 'USD', name: 'Dólar (USD, US$)' },
    { id: 'BRL', name: 'Reais (BRL, R$)' },
]

const redirect = (basePath, id, data) =>
    `/admin/enterpriseProducts/${data.enterpriseProductId}/show/1`

const FareAgeInputs = () => [
    <TextInput
        key="startAge"
        label="Idade Inicial"
        source="startAge"
        validate={[required()]}
    />,
    <TextInput
        key="endAge"
        label="Idade Final"
        source="endAge"
        validate={[required()]}
    />,
    <TextInput
        key="value"
        label="Valor"
        source="value"
        validate={[required()]}
        parse={currencyBRL}
    />,
    <SelectInput
        key="currency"
        label="Moeda"
        source="currency"
        choices={currencyChoices}
        validate={[required()]}
    />,
]

export const EnterpriseProductFareAgeEdit = (props) => {
    const transform = (data) => ({
        enterpriseProductId: data.enterpriseProductId,
        startAge: data.startAge,
        endAge: data.endAge,
        value: data.value,
        currency: data.currency,
    })

    return (
        <Edit
            {...props}
            title="Editar tarifa"
            mutationMode="pessimistic"
            transform={transform}
        >
            <SimpleForm redirect={redirect}>{FareAgeInputs()}</SimpleForm>
        </Edit>
    )
}

export const EnterpriseProductFareAgeCreate = (props) => {
    const location = useLocation()
    const enterpriseProductId =
        location.state && location.state.enterpriseProductId

    return (
        <Create {...props} title="Nova tarifa" mutationMode="pessimistic">
            <SimpleForm
                redirect={redirect}
                initialValues={{ enterpriseProductId, currency: 'USD' }}
            >
                {FareAgeInputs()}
            </SimpleForm>
        </Create>
    )
}
